export default class MarketoForms {
    constructor () {
        if (!window.MktoForms2)
            return

        this.listen()
    }

    listen () {
        window.MktoForms2
            .whenRendered(this.onRender.bind(this))
    }

    destyleMktoForm (mktoForm, options) {
        options = options || {}

        const formEl = mktoForm.getFormElem()[0]

        // remove element styles from <form> iand children
        if (!options.keepInline)
            Array.from(formEl.querySelectorAll('[style]'))
                .concat(formEl)
                .forEach((el) => el.removeAttribute('style'))

        // disable remote stylesheets and local <style>s
        if (!options.keepSheets)
            Array.from(document.styleSheets)
                .filter(ss => (ss.href || '').match(/forms2[^/]*\.css$/)
                    || formEl.contains(ss.ownerNode)
                    || ss.ownerNode.innerHTML.match(/#mktoForm_/))
                .forEach(ss => (ss.disabled = true))

        if (!options.moreStyles)
            formEl.setAttribute('data-styles-ready', 'true')
    }

    modifyElementClass (
        nodes,
        action,
        priClass,
        secClass,
        thiClass,
        fouClass
    ) {
        if (typeof nodes === 'string')
            nodes = document.querySelectorAll(nodes)

        Array.from(nodes)
            .forEach((node) => {
                if (priClass
                        && (action === 'add'
                            || action === 'replace'))
                    priClass.split(/\s+/g)
                        .filter((str) => (str || '').trim()
                            && !node.classList.contains(str))
                        .forEach((str) => node.classList.add(str))

                if (action === 'replace')
                    node.classList.remove(secClass)

                if (action === 'remove')
                    node.classList.remove(priClass)

                if (action === 'delete')
                    node.parentElement
                        .removeChild(node)

                if (action === 'wrap'
                        && !node.classList.contains('styled')) {
                    const div = document.createElement(priClass)

                    node.className += ' styled'
                    node.parentNode.insertBefore(div, node)

                    const next = node.nextElementSibling

                    div.appendChild(node)

                    if (next)
                        div.appendChild(next)

                    if (secClass)
                        div.classList.add(secClass)

                    if (thiClass)
                        div.classList.add(thiClass)

                    if (fouClass)
                        div.classList.add(fouClass)
                }
            })
    }

    onRender (form) {
        const formEl = form
            && form.getFormElem()[0]

        if (!formEl)
            return

        this.destyleMktoForm(form)

        this.modifyElementClass(formEl.querySelectorAll('.mktoClear'),
            'delete')

        this.modifyElementClass(formEl.querySelectorAll('.mktoOffset'),
            'delete')

        this.modifyElementClass(formEl.querySelectorAll('.mktoGutter'),
            'delete')

        this.modifyElementClass(formEl.querySelectorAll('.mktoCheckboxList'),
            'add', 'p-0 m-0')

        this.modifyElementClass(formEl.querySelectorAll('.mktoFormRow'),
            'add', 'form-group row mb-0')

        this.modifyElementClass(formEl.querySelectorAll('.mktoFormRow .mktoFormCol'),
            'add', 'col-12')

        if (formEl.parentElement
                && formEl.parentElement.getAttribute('data-cols') === '2')
            this.modifyElementClass(
                formEl.querySelectorAll('.mktoFormRow .mktoFormCol:not(:only-child)'),
                'add', 'col-md-6')

        this.modifyElementClass(formEl.querySelectorAll('.mktoButtonRow'),
            'add', 'py-3 pl-4 pr-0 border-top bg-lightest border-light col-12 mt-3')

        this.modifyElementClass(
            formEl.querySelectorAll(
                '.mktoField:not([type=checkbox]):not([type=date]):not([type=radio]):not([type=range])'
            ),
            'add', 'form-control form-control-alternative')

        this.modifyElementClass(formEl.querySelectorAll('.mktoButton'),
            'add', 'btn')

        this.modifyElementClass(formEl.querySelectorAll('.mktoLabel'),
            'add', 'mb-2')

        this.modifyElementClass(
            formEl.querySelectorAll(`.mktoForm input[type=checkbox],
            .mktoForm input[type=radio]`),
            'add', 'custom-control-input')

        this.modifyElementClass(formEl.querySelectorAll('.mktoForm input[type=range]'),
            'add', 'custom-control-range')

        this.modifyElementClass(formEl.querySelectorAll('.mktoCheckboxList > label'),
            'add', 'custom-control-label')

        this.modifyElementClass(
            formEl.querySelectorAll('.mktoForm input[type=checkbox]:not(.styled)'),
            'wrap', 'div', 'custom-control', 'custom-checkbox', 'mrgn-bottom-10')

        this.modifyElementClass(
            formEl.querySelectorAll('.mktoForm input[type=radio]:not(.styled)'),
            'wrap', 'div', 'custom-control', 'custom-radio', 'mrgn-bottom-10')

        Array.from(formEl.querySelectorAll('label'))
            .forEach(el => !el.textContent.trim()
                && el.parentNode.removeChild(el))

        Array.from(formEl.querySelectorAll('.mktoFormRow'))
            .filter((el) => {
                const isHidden = el.children.length === 1
                    && el.children[0].type === 'hidden'

                if (isHidden)
                    el.classList.add('mktoFormRowHidden')

                return !isHidden
            })

        const isSubscribe = ((formEl.parentElement || {}).parentElement || {}).parentElement
            && formEl.parentElement.parentElement.parentElement
                .classList.contains('subscribe-form')

        if (isSubscribe) {
            const inputEmail = formEl.querySelector('input[name=Email]')

            if (inputEmail && inputEmail.placeholder !== 'Email')
                inputEmail.placeholder = 'Email'

            if (inputEmail && inputEmail.previousElementSibling.tagName === 'LABEL')
                inputEmail.previousElementSibling.classList.add('visually-hidden')

            Array.from(formEl.querySelectorAll('button[type=submit]'))
                .forEach((el) => (el.innerText = 'Subscribe')
                    && el.classList.remove('btn')
                    && el.removeAttribute('aria-label'))
        }

        setTimeout(function () {
            // Hacky async workaround to avoid flashes of unstyled form elements
            formEl.setAttribute('data-ready', true)
        }, 17)
    }
}
